import * as React from 'react';
import { Transition } from 'react-transition-group';
import { isOnScreen, scrollToElement, } from '@core-front/helper';
import { AccordionContext, } from '../accordion/accordion';
import { AccordionItemContext, } from './accordion-item-context';
const AccordionItemCore = (props) => {
    const { openItems, setOpenItems } = React.useContext(AccordionContext);
    return (React.createElement(AccordionItemInner, Object.assign({}, props, { isOpen: (openItems && openItems.indexOf(props.id) > -1) || false, onToggle: (isOpen) => setOpenItems(props.id, isOpen) })));
};
export default AccordionItemCore;
export class AccordionItemInner extends React.Component {
    constructor(props) {
        super(props);
        this.accordion = null;
        this.handleTransitionEnd = (event) => {
            const { isOpen } = this.props;
            if (event.target === this.accordion && event.propertyName === 'height') {
                if (isOpen) {
                    this.setExpanded();
                }
                else {
                    this.setCollapsed();
                }
                this.scroll();
                this.setState({
                    isAnimating: false,
                });
            }
        };
        this.onMouseEnter = () => {
            if (!this.state.titleHovered) {
                this.setState({
                    titleHovered: true,
                });
            }
        };
        this.onMouseLeave = () => {
            if (this.state.titleHovered) {
                this.setState({
                    titleHovered: false,
                });
            }
        };
        this.handleMatch = () => {
            this.props.onToggle(true);
        };
        this.handleClick = this.handleClick.bind(this);
        this.isInitial = true;
        this.state = {
            collapseStyle: {
                height: '0px',
                overflow: 'hidden',
                visibility: 'hidden',
            },
            isAnimating: false,
            titleHovered: false,
        };
    }
    componentDidMount() {
        if (this.props.isOpen) {
            this.setExpanded();
        }
    }
    UNSAFE_componentWillReceiveProps() {
        this.isInitial = false;
    }
    componentDidUpdate(prevProps) {
        if (!this.accordion) {
            return;
        }
        if (this.props.isOpen !== prevProps.isOpen && !this.state.isAnimating) {
            this.setState({
                isAnimating: true,
            });
        }
        // expand
        if (this.props.isOpen && !prevProps.isOpen) {
            // have the element transition to the height of its inner content
            this.setContentStyleProperty('height', `${this.accordion.scrollHeight}px`);
            this.setContentStyleProperty('visibility', 'visible');
        }
        else if (!this.props.isOpen && prevProps.isOpen) {
            // collapse
            // explicitly set the element's height to its current pixel height, so we
            // aren't transitioning out of 'auto'
            this.setContentStyleProperty('height', `${this.accordion.scrollHeight}px`);
            requestAnimationFrame(() => {
                // "pausing" the JavaScript execution to let the rendering threads catch up
                // http://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
                setTimeout(() => {
                    this.setContentStyleProperty('height', '0px');
                    this.setContentStyleProperty('overflow', 'hidden');
                }, 0);
            });
        }
    }
    BEM() {
        const classArray = ['accordion__item'];
        if (this.props.isOpen) {
            classArray.push('is-open');
        }
        if (this.props.isInactive) {
            classArray.push('is-inactive');
        }
        if (this.props.type) {
            classArray.push('accordion__item--' + this.props.type);
            if (!this.props.backgroundColorClass) {
                classArray.push(`accordion__item--${this.props.type}-bg`);
            }
        }
        if (this.props.backgroundColorClass) {
            classArray.push(this.props.backgroundColorClass);
        }
        if (this.props.icon) {
            classArray.push('accordion__item--icon');
        }
        if (this.props.noContent) {
            classArray.push('accordion__item--no-content');
        }
        if (this.state.isAnimating) {
            classArray.push('is-animating');
        }
        if (this.state.titleHovered) {
            classArray.push('is-hovered');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    handleClick(event) {
        event.preventDefault();
        this.props.onToggle(!this.props.isOpen);
    }
    scroll() {
        if (!this.isInitial && this.context.openItems.indexOf(this.props.id) > -1 && !isOnScreen(this.props.id)) {
            scrollToElement(`${this.props.id}-header`);
        }
    }
    getArrow() {
        const { AccordionArrow } = this.props.components;
        return (React.createElement(AccordionArrow, { id: this.props.id, onClick: this.handleClick, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave }));
    }
    setContentStyleProperty(property, value) {
        this.setState((prevState) => {
            const newStyle = {
                [property]: value,
            };
            return {
                collapseStyle: Object.assign(Object.assign({}, prevState.collapseStyle), newStyle),
            };
        });
    }
    setCollapsed() {
        this.setContentStyleProperty('visibility', 'hidden');
    }
    setExpanded() {
        this.setContentStyleProperty('height', 'auto');
        this.setContentStyleProperty('overflow', 'visible');
        this.setContentStyleProperty('visibility', 'visible');
    }
    render() {
        const accordionItemContextValue = {
            accordionRef: (el) => this.accordion = el,
            collapseStyle: this.state.collapseStyle,
            icon: this.props.icon,
            id: this.props.id,
            isOpen: this.props.isOpen,
            noContent: this.props.noContent,
            onClick: this.handleClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
        };
        const { VisibilityProvider, HashTrigger } = this.props.components;
        return (React.createElement(AccordionItemContext.Provider, { value: accordionItemContextValue },
            React.createElement(VisibilityProvider, { isVisible: this.props.isOpen && !this.state.isAnimating },
                React.createElement(Transition, { in: this.props.isOpen, timeout: { enter: 0, exit: 0 } },
                    React.createElement(HashTrigger, { id: this.props.id, onMatch: this.handleMatch, renderWrapper: false },
                        React.createElement("div", { className: this.BEM(), style: this.state.isAnimating ? this.props.style : undefined, onTransitionEnd: this.handleTransitionEnd },
                            React.createElement("div", { className: "accordion__item-inner" }, this.props.children),
                            this.props.shouldRenderArrow && this.getArrow()))))));
    }
}
AccordionItemInner.contextType = AccordionContext;
